import { gql } from "@apollo/client";

export const GET_UNPAID_INVOICE_COUNT = gql`
  {
    unpaidInvoiceCount
  }
`;